export default "__VITE_ASSET__pYsTMW7r__"